import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { BrandButton } from '../../../components/button';

type Props = {
  loading: boolean;
};

export const LoginSubmit: FC<Props> = ({ loading }) => {
  return (
    <BrandButton
      expanded
      large
      id="modal_login_submit"
      type="submit"
      disabled={loading}
    >
      {loading ? (
        <FormattedMessage id="LoginSubmit.tsx/1" />
      ) : (
        <FormattedMessage id="LoginSubmit.tsx/2" />
      )}
    </BrandButton>
  );
};
